import React, { useState, useEffect, useContext, Fragment } from "react";
import { api_domain } from "../config"
import Menu from "../components/navbar.js";
import { AuthContext } from "../components/AuthContext";

export function Home() {
  const [summary, setSummary] = useState(null);
  const [batches, setBatches] = useState(null);
  const { basicHttpAuthString } = useContext(AuthContext);

  useEffect(() => {
    fetch(`${api_domain}/report/overall`, {
        headers: {
          Authorization: `${basicHttpAuthString}`
        }
      })
      .then((response) => response.json())
      .then((data) => setSummary(data));
    fetch(`${api_domain}/search/batch?order_by=id_desc&page=1&size=50`, {
        headers: {
          Authorization: `${basicHttpAuthString}`
        }
      })
      .then((response) => response.json())
      .then((data) => setBatches(data.items));
  }, [])

  return (
    <Fragment>
    <div className="container">
    <Menu/> 
    {/*<script>{menuFunction()}</script>*/}
        <div className="tools">
        <div className="titleMain">Explore, measure, and analyze ads from the web</div>
        <div style={{marginLeft: "20px"}} id="infoDiv" className="infoCont" >
            <div className="infoDivTitle">Total Ads Collected</div>
             <div className="num">{summary && summary.num_ads}</div>
        </div>
        <div id="infoDiv" className="infoCont" >
            <div className="infoDivTitle">Number of Websites Scanned</div>
             <div className="num">{summary && summary.num_parent_domains}</div>
        </div>
        <div id="infoDiv" className="infoCont" >
            <div className="infoDivTitle">Number of Days of Data</div>
            < div className="num">{summary && summary.batch_date_range_days}</div> 
        </div>
    </div>
     <div className="titleWarning"><b>Warning: NOT FOR ALL AUDIENCES.</b> This archive contains images and metadata of advertisements appearing on websites that our web crawlers visited. <b>Please be aware that some of the content in these advertisements may be problematic, including adult content or disturbing images.</b> By default, you will see ad screenshots as blurred; you can click on them to unblur.</div>
    <div className="titleMinorForTable">Last added</div>
    {batches &&
        <div id="dataTableDiv">
        <table className="batchDataTable">
            <tbody>
            <tr>
              <th>Batch Id</th>
              <th>Batch Date</th>
              <th>Batch Type</th>
              <th>Batch Name</th>
            </tr>
            {batches.map((batch) => (
              <tr key={batch.id}>
                <td>
                  <a href={`/batch/${batch.id}`}>
                    {batch.id}
                  </a>
                </td>
                <td>
                  {new Date(batch.batch_date).toLocaleDateString("en-US")}
                </td>
                <td>
                  {batch.batch_type === 1 ? "crawl" : "dataset"}
                </td>
                <td>
                  {batch.human_name}
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>}
  </div>
   </Fragment>
  );
}
